<template lang="pug">
.image-preview-modal-back(v-if="show" @click.stop="onClose")
  img.image-preview-modal__close(:src="require('@/assets/times.svg')" alt="Cerrar" @click.stop="onClose")
  .image-preview-modal(@click.stop="")
    img.image-preview-modal__img(v-if="src" :src="src" :alt="alt")
</template>

<script>
export default {
  name: 'ImagePreviewModal',

  props: {
    show: {
      type: Boolean,
      default: false
    },
    src: {
      type: String,
      default: ''
    },
    alt: {
      type: String,
      default: ''
    }
  },

  methods: {
    onClose () {
      this.$emit('close')
    }
  }
}
</script>

<style lang="stylus" scoped>
.image-preview-modal-back
  position fixed
  top 0
  left 0
  width 100vw
  height 100vh
  background-color rgba(0, 0, 0, 0.85)
  z-index 12000
  display flex
  justify-content center
  align-items center
  cursor pointer
  padding 3.5rem 1.5rem 1.5rem
  box-sizing border-box

.image-preview-modal
  display flex
  justify-content center
  align-items center
  cursor default

.image-preview-modal__close
  position fixed
  top 1rem
  right 1rem
  width 1.5rem
  height 1.5rem
  cursor pointer
  opacity .85
  filter brightness(0) invert(1)
  z-index 1

  &:hover
    opacity 1

.image-preview-modal__img
  display block
  max-width calc(100vw - 3rem)
  max-height calc(100vh - 5rem)
  width auto
  height auto
  border-radius .4em
</style>



// WEBPACK FOOTER //
// src/components/elements/ImagePreviewModal.vue